import React, { useState, useEffect, useRef, forwardRef } from "react";
import {
  Avatar,
  Badge,
  Box, 
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import firebase, { auth } from "../utils/firebaseConfig"

import { deleteItem } from "../actions";

import tableIcons from "../components/tableFormatting/tableIcons";


const NotificationsList = () => {
  const [isLoading, setIsLoading] = useState(true);

  const localStore = useSelector(state => state.nanoCompDataReducer);
  const [data, setData] = useState([]);
  const [selectedDataSet, setSelectedDataSet] = useState(1);
  const auth = useSelector(state => state.firebase);

  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);

    }, 1000)
  },[])


  useEffect(() => {
    async function getdata() {
      const ref = firebase
          .firestore()
          .collection("nanoCompetencies");
        const snapshot = await ref.get();
        const fetchedData = []
        const sortedData = []
        snapshot.forEach(doc => {
          fetchedData.push(doc.data());
        });
      fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)
        if(selectedDataSet == 1) {
          setData(fetchedData)
        }
        fetchedData.map((d,i) => {
          if(d.author == auth.auth.uid) {
            sortedData.push(d)
          }
        })
        if(selectedDataSet == 2){
          setData(sortedData)
        }
      }
      getdata()

  },[localStore, dispatch, selectedDataSet])

  const notiData = [
    {
      id: 0,
      author: "Greg McLanes",
      type: "feedback",
      name: "Data Visualisation",
      description: "Hi! That was a great analysis of Heatmapping! 10/10",
      date: "29-May-2020",
      icon: "CommentIcon",
    },
    {
      id: 1,
      author: "Milla Martiini",
      type: "like",
      name: "Data Visualisation",
      description: "Liked your comment!",
      date: "29-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 2,
      author: "Steve Gimbles",
      type: "like",
      name: "Professional Communication",
      description: "Liked your comment!",
      date: "28-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 3,
      author: "Barney Roots",
      type: "reminder",
      name: "Professional Communication",
      description: "Your fith assignment is due in 2 days, good luck!",
      date: "27-May-2020",
      icon: "PriorityHighIcon",
    },
    {
      id: 4,
      author: "Anna Koivunen",
      type: "like",
      name: "Professional Communication",
      description: "Liked your comment!",
      date: "27-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 5,
      author: "Greg McLanes",
      type: "feedback",
      name: "Data Visualisation",
      description: "I think you should pay more attention to the theory side before attempting the quiz, otherwise all good for module 2!",
      date: "27-May-2020",
      icon: "CommentIcon",
    },
    {
      id: 6,
      author: "Tina Baker",
      type: "like",
      name: "Professional Communication",
      description: "Liked your comment!",
      date: "26-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 7,
      author: "Rosa Parkki",
      type: "like",
      name: "Data Visualisation",
      description: "Liked your comment!",
      date: "26-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 8,
      author: "Greg McLanes",
      type: "submission",
      name: "Data Visualisation",
      description: "Submission received! I will look into this as soon as possible",
      date: "23-May-2020",
      icon: "Check",
    },
    {
      id: 9,
      author: "Barney Roots",
      type: "submission",
      name: "Professional Communication",
      description: "Submission received! I will look into this as soon as possible",
      date: "23-May-2020",
      icon: "Check",
    },
    {
      id: 10,
      author: "Barney Roots",
      type: "reminder",
      name: "Professional Communication",
      description: "Your fifth assignment is due in 2 days, good luck!",
      date: "22-May-2020",
      icon: "PriorityHighIcon",
    },
    {
      id: 11,
      author: "Barney Roots",
      type: "like",
      name: "Artificial Intelligence",
      description: "Liked your comment!",
      date: "20-May-2020",
      icon: "ThumbUpIcon",
    },
    {
      id: 12,
      author: "Melissa Uronen",
      type: "like",
      name: "Artificial Intelligence",
      description: "Liked your comment!",
      date: "20-May-2020",
      icon: "ThumbUpIcon",
    },
  ];

  const [notificationData, setNotificationData] = useState(notiData);

  function stringToColor(userName) {
    let hash = 0;
    let i;
    if(userName != undefined) {
    for (i = 0; i < userName.length; i += 1) {
      hash = userName.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
    } 
  }

  function stringAvatar(userName) {
    if(userName != undefined) {
    return {
      sx: {
        bgcolor: stringToColor(userName),
        fontSize: "14px",
      },
      children: `${userName.split(' ')[0][0]}${userName.split(' ')[1][0]}`,
    };
  } 
  }


  function handleRemove(d, i) {
    const newValues = notificationData.filter((item) => item.id !== d.id);

    setNotificationData(newValues);
  }


return (
  <div>
    {isLoading == true ? (

      <CircularProgress style={{ display: "flex", position: "absolute", top: "50%", left: "50%", marginRight: "-50%", transform: "translate(-50%, -50%)" }} />

    ) : (
    <>

      <IconButton
        style={{ position: "absolute", left: "5vw", marginTop: "20px" }}
      >
        <Link 
          to={-1}> 
          <tableIcons.PreviousPage color="primary"  />
        </Link>
      </IconButton>
    
      <h1 className="pageHeader1">Notifications</h1>
        
      {notificationData.length < 1 ? (
        <div>
          <Box textAlign="center">

          <h3>You currently have no Notifications</h3>
          <h3>Please proceed by participating in content</h3>
          </Box>
        </div>
      ) : (
        <div>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
        
            <List style={{ margin: "5vw 5vw 0 5vw" }}>
              {notificationData.map((d, i) =>(
                <>
                  <ListItem
                    key={i}
                    secondaryAction={
                      <Tooltip title="Delete">
                      <IconButton edge="end" aria-label="delete" onClick={() => handleRemove(d)}>
                        <tableIcons.Clear />
                      </IconButton>
                    </Tooltip>
                    }
                  >

                    <ListItemIcon>
                      <Tooltip title={d.author}>

                        {d.type == "feedback" ? (
                          <Badge anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={<tableIcons.CommentIcon />}>
                            <Avatar {...stringAvatar(d.author)} style={{ color: "#000", height: "30px", width: "30px" }} />
                          </Badge>
                        ) : d.type == "like" ? (
                          <Badge anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={<tableIcons.ThumbUpIcon />}>
                            <Avatar {...stringAvatar(d.author)} style={{ color: "#000", height: "30px", width: "30px" }} />
                          </Badge>
                        ) : d.type == "submission" ? (
                          <Badge anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={<tableIcons.Check />}>
                            <Avatar {...stringAvatar(d.author)} style={{ color: "#000", height: "30px", width: "30px" }} />
                          </Badge>
                        ) : (
                          <Badge anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={<tableIcons.PriorityHighIcon />}>
                            <Avatar {...stringAvatar(d.author)} style={{ color: "#000", height: "30px", width: "30px" }} />
                          </Badge>
                        )}

                      </Tooltip>
                    </ListItemIcon>

                    <>
                    
                      <ListItemText
                        primary={d.name}
                        secondary={d.description}
                      />

                    </>
                  </ListItem>

                </>

              ))}
            </List>
          </Grid>
        </div>
      )}
      </>
    )}
  </div>
  );
};

export default NotificationsList;